/**
 * Advertising inventory specs for Avto-Tarix.
 * Aligned with IAB / regional auto media kits (Spot, Autocenter, Mashina).
 */

export const AD_POSITIONS = [
  {
    value: 'header',
    label: 'Header Billboard',
    labelRu: 'Шапка (билборд)',
    size: '970×250',
    aspect: '970 / 250',
    accept: 'JPG, PNG, GIF, MP4 · до 2 МБ',
    hint: 'Премиум-слот под шапкой. Рекомендуем 970×250 (IAB Billboard).'
  },
  {
    value: 'left',
    label: 'Sidebar Left',
    labelRu: 'Слева (десктоп)',
    size: '300×250 или 300×600',
    aspect: '300 / 250',
    accept: 'JPG, PNG, GIF, MP4 · до 1.5 МБ',
    hint: 'Колонка 300px. Лучше всего заходят Medium Rectangle 300×250 и Half-page 300×600.'
  },
  {
    value: 'right',
    label: 'Sidebar Right',
    labelRu: 'Справа (десктоп)',
    size: '300×250 или 300×600',
    aspect: '300 / 250',
    accept: 'JPG, PNG, GIF, MP4 · до 1.5 МБ',
    hint: 'Колонка 300px. Можно ставить несколько баннеров друг под другом.'
  },
  {
    value: 'mobile',
    label: 'Mobile Banner',
    labelRu: 'Мобильный баннер',
    size: '320×100 или 640×200',
    aspect: '16 / 5',
    accept: 'JPG, PNG, GIF, MP4 · до 1 МБ',
    hint: 'Показывается вместо сайдбаров на экранах ≤960px.'
  },
  {
    value: 'between',
    label: 'Native Feed',
    labelRu: 'В ленте (натив)',
    size: 'адаптив до 970×250',
    aspect: '16 / 5',
    accept: 'JPG, PNG, GIF, MP4 · до 2 МБ',
    hint: 'Встраивается между карточками DTP. Без жёсткого crop — креатив виден целиком.'
  },
  {
    value: 'detail',
    label: 'Car Detail',
    labelRu: 'Страница авто',
    size: '728×90 или 300×250',
    aspect: '728 / 90',
    accept: 'JPG, PNG, GIF, MP4 · до 1.5 МБ',
    hint: 'Высокий intent: пользователь уже смотрит конкретную запись.'
  }
];

export function getAdPositionMeta(position) {
  return AD_POSITIONS.find((p) => p.value === position) || null;
}

export function adMediaUrl(apiUrl, ad) {
  const file = ad?.mediaType === 'video' ? ad.video : (ad?.image || ad?.video);
  if (!file) return '';
  return `${apiUrl}/uploads/${file}`;
}
